var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg9Payment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#415fb5;}.cls-2{fill:#577ef2;}.cls-3{fill:#202d35;}.cls-4{fill:#273640;}.cls-5{fill:#1d252d;}.cls-6{fill:#f7b011;}.cls-7{fill:#fcee21;}.cls-8{fill:#c8c2b5;}.cls-9{fill:#e7e5e0;}.cls-10{fill:#ce930e;}.cls-11{fill:#613f1e;}.cls-12{fill:#75a534;}.cls-13{fill:#8cc63f;}.cls-14{fill:#222325;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9-payment",
    "data-name": "9-payment"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,5V59a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V5a3.66,3.66,0,0,1,.13-1A4,4,0,0,1,5,1H31a4,4,0,0,1,3.87,3A3.66,3.66,0,0,1,35,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35,5V59a4,4,0,0,1-4,4h-.47C20.48,54.71,13.17,30.14,13,1H31a4,4,0,0,1,3.87,3A3.66,3.66,0,0,1,35,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.87,4H27a1,1,0,0,0-1,1,1,1,0,0,1-1,1H11a1,1,0,0,1-1-1A1,1,0,0,0,9,4H1.13A4,4,0,0,1,5,1H31A4,4,0,0,1,34.87,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.87,4H27a1,1,0,0,0-1,1,1,1,0,0,1-1,1H13.1c0-1.65-.09-3.32-.09-5H31A4,4,0,0,1,34.87,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31,0H5A5,5,0,0,0,0,5V59a5,5,0,0,0,5,5H31a3.94,3.94,0,0,0,.77-.07A5,5,0,0,0,36,59V5A5,5,0,0,0,31,0Zm3,59a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2H31a3,3,0,0,1,3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36,5V59a5,5,0,0,1-4.23,4.93A17.09,17.09,0,0,1,29.41,62H31a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3H13c0-.66,0-1.33,0-2H31A5,5,0,0,1,36,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5,12a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0v1A1,1,0,0,1,5,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,12a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0v1A1,1,0,0,1,8,12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 8,
    y: 28,
    width: 36,
    height: 23,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44,30V49a2,2,0,0,1-2,2H32.43A23.89,23.89,0,0,1,16,28H42A2,2,0,0,1,44,30Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 12,
    y: 32,
    width: 9,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21,32v6H18.1a23.64,23.64,0,0,1-1.77-6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18 32 18 38 16 38 16 36 12 36 12 34 16 34 16 32 18 32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18,32v5.78A24.21,24.21,0,0,1,16.33,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38,42a2.94,2.94,0,0,0-1.5.42A2.94,2.94,0,0,0,35,42a3,3,0,0,0,0,6,2.94,2.94,0,0,0,1.5-.42A2.94,2.94,0,0,0,38,48a3,3,0,0,0,0-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38,43a2,2,0,0,0-1.5.69,2,2,0,1,0,0,2.62A2,2,0,1,0,38,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M23,44H13a2,2,0,0,1,0-4H23a2,2,0,0,1,0,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M15,48H14a2,2,0,0,1,0-4h1a2,2,0,0,1,0,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M19,48H18a2,2,0,0,1,0-4h1a2,2,0,0,1,0,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M23,43H13a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M15,47H14a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M19,47H18a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M63,17a14.26,14.26,0,0,1-3.27,9A20.15,20.15,0,0,1,44,33a21.82,21.82,0,0,1-8.68-1.78A5,5,0,0,1,31.17,33c.86-.15,1.55-1.38,1.76-3C28.14,27.08,25,22.35,25,17,25,9.46,31.2,3.14,39.53,1.45A21.86,21.86,0,0,1,44,1C54.49,1,63,8.16,63,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M63,17a14.26,14.26,0,0,1-3.27,9c-.24,0-.49,0-.73,0A20,20,0,0,1,39,6a19.54,19.54,0,0,1,.53-4.55A21.86,21.86,0,0,1,44,1C54.49,1,63,8.16,63,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M52,12a2,2,0,0,1-.59,1.41l-6.64,6.64-2.36,2.36a2,2,0,0,1-2.82,0l-3-3a2,2,0,1,1,2.82-2.82L41,18.17l1.25-1.25,6.34-6.33A2,2,0,0,1,52,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M52,12a2,2,0,0,1-.59,1.41l-6.64,6.64a19.52,19.52,0,0,1-2.52-3.13l6.34-6.33A2,2,0,0,1,52,12Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M31,64H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0H31a5,5,0,0,1,4.33,2.5,1,1,0,1,1-1.73,1A3,3,0,0,0,31,2H5A3,3,0,0,0,2,5V59a3,3,0,0,0,3,3H31a3,3,0,0,0,3-3V51a1,1,0,0,1,2,0v8A5,5,0,0,1,31,64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M25,7H11A2,2,0,0,1,9,5H1V3H9a2,2,0,0,1,2,2H25a2,2,0,0,1,2-2h6V5H27A2,2,0,0,1,25,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M44,34a22.66,22.66,0,0,1-8.39-1.58A6.62,6.62,0,0,1,31,34a1,1,0,0,1,0-2c.14,0,.58-.47.83-1.52C26.91,27.26,24,22.27,24,17,24,7.63,33,0,44,0S64,7.63,64,17,55,34,44,34Zm-8.68-3.78a.93.93,0,0,1,.4.09A20.75,20.75,0,0,0,44,32c9.93,0,18-6.73,18-15S53.93,2,44,2,26,8.73,26,17c0,4.77,2.78,9.31,7.45,12.13a1,1,0,0,1,.47,1,7.93,7.93,0,0,1-.27,1.29,2.34,2.34,0,0,0,.84-.73A1,1,0,0,1,35.32,30.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M42,52H10a3,3,0,0,1-3-3V30a3,3,0,0,1,3-3H30v2H10a1,1,0,0,0-1,1V49a1,1,0,0,0,1,1H42a1,1,0,0,0,1-1V33h2V49A3,3,0,0,1,42,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M21,39H12a1,1,0,0,1-1-1V32a1,1,0,0,1,1-1h9a1,1,0,0,1,1,1v6A1,1,0,0,1,21,39Zm-8-2h7V33H13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 12,
    y: 34,
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 16,
    y: 32,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M38,48a2.92,2.92,0,0,1-1.5-.41A2.92,2.92,0,0,1,35,48a3,3,0,0,1,0-6,2.92,2.92,0,0,1,1.5.41A2.92,2.92,0,0,1,38,42a3,3,0,0,1,0,6Zm-1.5-2.69a1,1,0,0,1,.75.34,1,1,0,1,0,0-1.3,1,1,0,0,1-1.5,0,1,1,0,1,0,0,1.3A1,1,0,0,1,36.5,45.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M23,43H13a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M15,47H14a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M19,47H18a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M41,24a3,3,0,0,1-2.12-.88l-3-3a3,3,0,0,1,0-4.24,3.08,3.08,0,0,1,4.24,0l.88.88,6.88-6.88a3.08,3.08,0,0,1,4.24,0,3,3,0,0,1,0,4.24l-9,9A3,3,0,0,1,41,24Zm-3-7a1,1,0,0,0-.71,1.71l3,3a1,1,0,0,0,1.42,0l9-9a1,1,0,0,0,0-1.42,1,1,0,0,0-1.42,0l-7.58,7.59a1,1,0,0,1-1.42,0l-1.58-1.59A1,1,0,0,0,38,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M5,12a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0v1A1,1,0,0,1,5,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M8,12a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0v1A1,1,0,0,1,8,12Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9Payment);
export default __webpack_public_path__ + "static/media/9-payment.0b5511635449a82939615cd7f1c29de7.svg";
export { ForwardRef as ReactComponent };